// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._3W-26fmi3tFfon {\n  display: inline-block;\n  line-height: 1;\n}\n._3BFOeJzluvmb6s svg {\n  height: 14px;\n  width: 14px;\n  line-height: 14px;\n}\n.j0fswhntKdStWa svg {\n  height: 16px;\n  width: 16px;\n  line-height: 16px;\n}\n._1X1mC-Jr6D4C2k svg {\n  height: 20px;\n  width: 20px;\n  line-height: 20px;\n}\n.F1vyv38WnORG_w svg {\n  height: 24px;\n  width: 24px;\n  line-height: 24px;\n}\n._1519ZWel5_WuNz {\n  box-sizing: border-box;\n  padding: 3px 3px;\n}\n._3--TIajgxM0c0V {\n  box-sizing: border-box;\n  padding: 2px 2px;\n}\n._1NjiSTp3m4qWBz {\n  box-sizing: border-box;\n  padding: 6px 6px;\n}\n._3ETUKShsSse8pH {\n  box-sizing: border-box;\n  padding: 4px 4px;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"nch-icon": "_3W-26fmi3tFfon",
	"nch-icon--xsmall": "_3BFOeJzluvmb6s",
	"nch-icon--small": "j0fswhntKdStWa",
	"nch-icon--medium": "_1X1mC-Jr6D4C2k",
	"nch-icon--large": "F1vyv38WnORG_w",
	"nch-icon--xsmall-block": "_1519ZWel5_WuNz",
	"nch-icon--small-block": "_3--TIajgxM0c0V",
	"nch-icon--medium-block": "_1NjiSTp3m4qWBz",
	"nch-icon--large-block": "_3ETUKShsSse8pH"
};
export default ___CSS_LOADER_EXPORT___;
